import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToChucSanPham } from 'src/app/shared/ToChucSanPham.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class ToChucSanPhamService extends BaseService{
    list: ToChucSanPham[] | undefined;
    list001: ToChucSanPham[] | undefined;
    formData!: ToChucSanPham;

    displayColumns001: string[] = ['STT', 'DanhMucSanPhamID','Note', 'Save'];
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "ToChucSanPham";
    }
}

